import { render, staticRenderFns } from "./PivotTemplateSelection.vue?vue&type=template&id=5af9541e&scoped=true&"
import script from "./PivotTemplateSelection.vue?vue&type=script&lang=ts&"
export * from "./PivotTemplateSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af9541e",
  null
  
)

export default component.exports